export default __webpack_public_path__ + "static/media/12-23.df53e58a.jpeg";